import React, { Fragment } from 'react';
import AbstractComponent from '../../AbstractComponent';
import InputMasked from '../../layout/input/InputMasked';
import InputLabel from '../../layout/input/InputLabel';

class Compartilhada extends AbstractComponent {     
    render() {
        return(
            <Fragment>
                <InputMasked
                    md={12} 
                    xs={12} 
                    sm={12} 
                    lg={12}
                    id="endpoint"
                    nome="endpoint"
                    value={this.props.form.endpoint}                                 
                    defaultFoco={true}
                    pattern="[a-zA-Z0-9\-\_]+$"
                    erro={this.props.erroForm.endpoint}
                    onChange={(e) => this.props.onChange(e)}
                >                    
                    Usuário (Somente Letras, Números, - (menos), _ (underline))
                </InputMasked>

                <InputLabel
                    md={12} 
                    xs={12} 
                    sm={12} 
                    lg={12}
                    value={"https://coletapedido.com.br/" + this.props.form.endpoint + "/"}                    
                >
                    Seu endereço
                </InputLabel>
            </Fragment>            
        )
    }
}

export default Compartilhada;